import React from 'react';
import { Table } from 'react-bootstrap';

const DatabaseErrorsTable = ({ errors }) => {
  if (!errors || errors.length === 0) return null;

  return (
    <div className="mb-3">
      <h6 className="text-danger">Database Errors</h6>
      <Table striped bordered hover size="sm">
        <thead>
          <tr>
            <th>Row</th>
            <th>Email</th>
            <th>Error</th>
          </tr>
        </thead>
        <tbody>
          {errors.map((error, index) => (
            <tr key={index}>
              <td>{error.row}</td>
              <td>{error.email}</td>
              <td>{error.error}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default DatabaseErrorsTable;